<template>
    <div class="card-item" :class="{ 'card-item--expired': isExpired }" :style="cardStyle">
        <img class="card-logo" :src="cardLogo"/>
        <div class="font-22 text-white mt-2">{{ getCardNumber() }}</div>
        <div class="row text-white mt-3">
            <div class="col">
                <div class="font-10">{{ $t('Month/Year') }}</div>
                <div class="font-12">{{ getExpirationDateDetails(card) }}</div>
            </div>
            <div class="col-5">
                <div class="font-10">{{ $t('cvc2/cvv2') }}</div>
                <div class="font-12">{{ 'XXX' }}</div>
            </div>
        </div>
        <div class="row text-white mt-3">
            <div class="col-5">
                <div class="font-10">{{ getCardName() }}</div>
            </div>
            <div class="col">
                <div v-if="false && isDefaultPayment" class="font-10 text-uppercase text-secondary font-weight-bold text-right">{{ $t('Default Payment') }}</div>
                <div v-if="!isDefaultPayment && isValidProcessor && !noActions" class="font-10 text-uppercase text-center">
                    <div v-if="false" class="pointer p-1 border rounded-sm border-primary text-primary" @click="handleMakeDefault">{{ $t('Make Default Payment') }}</div>
                    <div class="mt-1 pointer p-1 border rounded-sm border-danger text-danger" @click="handleDelete">{{ $t('Remove Payment Method') }}</div>
                </div>
                <div v-if="!isValidProcessor && !noActions" class="font-10 text-uppercase text-center" >
                    <div class="pointer p-1 border rounded-sm border-warning text-primary" @click="handleReVerify">{{ $t('Card Requires Verification') }}</div>
                </div>
            </div>
        </div>
        <div v-if="isExpired" class="card-item__expired-overlay" aria-label="Card expired">
            <span class="card-item__expired-stamp">{{ $t('EXPIRED') }}</span>
        </div>
    </div>
</template>

<script>
import cardFront from "../../../theme/assets/images/card-front.png"
import cardLogos from "../../dashboard/constants/card-images";
import { isCardExpired } from "../../dashboard/utils/cardExpiry";

export default {
    name: "CardItem",
    props: {
        card: Object,
        isDefaultPayment: Boolean,
        isValidProcessor: Boolean,
        noActions: {
            type: Boolean,
            default: false
        }

    },
    computed: {
        cardStyle() {
            return {
                backgroundImage : "url("+ cardFront +")",
            }
        },
        cardLogo() {
            let brand = String(this.card?.card?.verification?.network).toLowerCase()
            return cardLogos[brand];
        },
        isExpired() {
            return isCardExpired(this.card);
        },
    },
    methods: {
        handleMakeDefault() {
            this.$emit('make-default')
        },
        handleDelete() {
            this.$fnModals.confirm(this.$t('Are you sure you want to remove this Card?')).then(value => {
                if(value) {
                    this.$emit('delete');
                }
            })
        },
        handleReVerify() {
            this.$fnModals.confirm(this.$t('You will be asked to re-enter your card details now. Proceed?')).then(value => {
                if(value) {
                    this.$emit('reverify');
                }
            })
        },
        getExpirationDateDetails(card) {
            try {
                if(card?.card?.exp_month && card?.card?.exp_year) {
                    return card.card.exp_month +'/'+ card.card.exp_year;
                } else if(card.card?.card?.expirationDate) {
                    let exp = card.card.card.expirationDate.toString()
                    return exp.substring(0,2) + '/' + exp.substring(2);
                }else if(this.card?.card_expiration) {
                    return this.card?.card_expiration;
                } else {
                    return "";
                }
            } catch (error) {
                return "";
            }
        },
        getCardNumber() {
            if(this.card.card?.cardNumber) {
                return this.card.card.cardNumber;
            }else if(this.card?.card_number) {
                return this.card?.card_number;
            }else if(this.card.card?.card?.cardLastFour) {
                return '**********' + this.card.card.card.cardLastFour;
            }
        },
        getCardName() {
            if(this.card.card?.name) {
                return this.card.card.name;
            } else if (this.card.card?.card?.firstName && this.card.card?.card?.lastName) {
                return this.card.card.card.firstName + ' ' + this.card.card.card.lastName;
            }
        }
    }
}
</script>

<style scoped>
.card-item {
    position: relative;
}

/* Muted tint on the whole card when expired */
.card-item--expired::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.25);
    pointer-events: none;
}

/* Engraved diagonal stamp */
.card-item__expired-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    border-radius: 12px;
    overflow: hidden;
}

.card-item__expired-stamp {
    display: inline-block;
    padding: 4px 14px;
    border: 2px solid rgba(255, 80, 80, 0.75);
    border-radius: 4px;
    color: rgba(255, 80, 80, 0.85);
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    transform: rotate(-22deg);
    /* Engraved look: inner shadow + slight text-shadow offset */
    text-shadow:
        1px 1px 2px rgba(0, 0, 0, 0.55),
        -1px -1px 1px rgba(255, 255, 255, 0.12);
    box-shadow:
        inset 0 1px 3px rgba(0, 0, 0, 0.4),
        0 1px 1px rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.18);
    backdrop-filter: blur(1px);
    user-select: none;
}

</style>
